module.exports = __webpack_public_path__ + "img/bluedelicon.74af0081.svg";